<script setup>
import { ref, computed } from "vue";
import { useUserGroupStore } from "@/stores/useUserGroupStore";
import DeleteConfirmModal from "@/components/Generics/DeleteConfirmModal.vue";

const emit = defineEmits(["close", "refresh", "notify"]);
const store = useUserGroupStore();

const selectedCount = computed(() => store.selectedAssociationIds.length);

// Congelar count para a mensagem não mudar após clique/delete/refresh
const frozenCount = ref(0);

function freezeCount() {
  frozenCount.value = selectedCount.value;
}

const title = "Apagar Vínculos em Lote";

const messageTitle = computed(() => {
  const n = frozenCount.value || selectedCount.value;
  if (n <= 1) return "Você está prestes a apagar 1 vínculo selecionado.";
  return `Você está prestes a apagar ${n} vínculos selecionados.`;
});

const messageSubtitle = "Esta ação não pode ser desfeita.";

const successMessage = computed(() => {
  const n = frozenCount.value || selectedCount.value;
  if (n <= 1) return "Vínculo Pessoa-Grupo apagado com sucesso.";
  return `${n} vínculos Pessoa-Grupo apagados com sucesso.`;
});

function buildErrorMessage(error) {
  return (
    error?.response?.data?.message ||
    error?.message ||
    "Ocorreu um erro ao excluir os vínculos."
  );
}

async function onConfirm() {
  freezeCount();

  try {
    await store.deleteSelectedAssociations();

    emit("notify", {
      type: "success",
      message: successMessage.value,
    });

    emit("refresh");
    emit("close");
  } catch (error) {
    const msg = buildErrorMessage(error);

    emit("notify", {
      type: "error",
      message: msg,
    });

    throw new Error(msg);
  }
}
</script>

<template>
  <DeleteConfirmModal
    :show="true"
    :title="title"
    :messageTitle="messageTitle"
    :messageSubtitle="messageSubtitle"
    confirmText="Sim, apagar"
    cancelText="Cancelar"
    loadingText="Apagando..."
    :onConfirm="onConfirm"
    @close="emit('close')"
  />
</template>
